<template>
  <div class="data-team" v-ps>
    <div class="team">
      <div class="team-content" v-for="(member, index) in teamMembers" :key="index">
        <div class="member-content">
          <div class="member-avatar">
            <staff-popover :staffId="member.id">
              <template v-slot:reference>
                <staff-avatar class="avatar" :size="30" :user="member"></staff-avatar>
              </template>
            </staff-popover>
          </div>
          <div class="member-info">
            <div style="display: flex">
              <div class="name" v-tip>{{ member.name }}</div>
              <div class="role">
                <el-tag :type="member.role === '负责人' ? '' : 'info'">{{ member.role }}</el-tag>
              </div>
            </div>
            <div class="operation">
              <base-button
                v-if="has_TM_privilege && member.role !== '负责人'"
                @click="removeMembers(member)"
                type="text"
              >
                移除
              </base-button>
              <base-button
                v-if="has_TL_privilege && hasPermission && member.role !== '参与人'"
                type="text"
                style="margin-left: 8px"
                @click="$refs.updateOwnerDialog.open()"
              >
                更换
              </base-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="add-member pointer" v-if="hasPermission && has_TM_privilege">
      <span @click="$refs.partSelectDialog.open()">
        <svg-icon icon-class="detail_add-member" style="font-size: 13px"></svg-icon>
      </span>
      <base-button class="operate-item" @click="$refs.partSelectDialog.open()" type="text">
        添加参与人
      </base-button>
    </div>
    <update-owner-dialog
      ref="updateOwnerDialog"
      :app-id="appId"
      @select="updateOwner"
    ></update-owner-dialog>
    <select-user-dialog
      multiple
      ref="partSelectDialog"
      :app-id="appId"
      title="添加参与人"
      @select="handlePart"
    ></select-user-dialog>
  </div>
</template>

<script>
import BaseButton from "@/components/UIComponents/Button"
import { updateOwner, updateParticipants } from "@/api/sheet/sheetData"
import SelectUserDialog from "@/components/SelectUserDialog"
import UpdateOwnerDialog from "@/components/Sheet/DetailDialog/UpdateOwnerDialog"
import { getUser, initUserData } from "@/utils/user"
import StaffPopover from "@/components/BaseComponents/StaffPopover"
import { checkPermission } from "@/utils/checkPermission"
import StaffAvatar from "@/components/StaffAvatar"

export default {
  name: "DataTeam",
  components: {
    StaffAvatar,
    BaseButton,
    SelectUserDialog,
    UpdateOwnerDialog,
    StaffPopover
  },
  props: {
    sheetData: Object,
    appId: String,
    sheetDef: Object
  },
  data() {
    return {}
  },
  computed: {
    // 团队人员
    teamMembers() {
      if (!this.sheetData.participants) return []
      let participants = this.sheetData.participants.map(id => {
        return {
          id,
          role: this.sheetData.ownerId === id ? "负责人" : "参与人",
          name: getUser(id)?.name,
          avatar: getUser(id)?.avatar
        }
      })
      let obj = {}
      for (let i = 0; i < participants.length; i++) {
        if (participants[i].role === "负责人") {
          obj = participants[i]
          participants.splice(i, 1)
          break
        }
      }
      participants.unshift(obj)
      return participants
    },
    // 是否有更换负责人权限
    has_TL_privilege() {
      return (
        !this.sheetDef.forbiddenOperations.includes("TL") &&
        checkPermission({
          appId: this.appId,

          sheetId: this.sheetData?.sheetId,
          pri: "TL",
          sheetData: this.sheetData
        })
      )
    },
    // 是否有编辑团队成员权限
    has_TM_privilege() {
      return (
        !this.sheetDef.forbiddenOperations.includes("TM") &&
        checkPermission({
          appId: this.appId,
          sheetId: this.sheetData?.sheetId,
          pri: "TM",
          sheetData: this.sheetData
        })
      )
    },
    hasPermission() {
      return this.has_TL_privilege || this.has_TM_privilege
    }
  },
  created() {
    initUserData(this.appId)
  },
  methods: {
    updateOwner({ ownerId, partFlag }) {
      updateOwner(this.sheetData.sheetId, this.sheetData.id, ownerId, partFlag).then(() => {
        let participants = this.sheetData.participants
        if (!partFlag) {
          participants.splice(
            participants.findIndex(item => item === this.sheetData.ownerId),
            1
          )
        }
        this.sheetData.ownerId = ownerId
        if (!participants.includes(ownerId)) {
          participants.push(ownerId)
        }
        this.$message.success("操作成功!")
        this.$emit("change", "owner")
      })
    },
    // 移除参与者
    removeMembers(params) {
      let removeArr = [].concat(params)
      let removeArrMap = removeArr.map(i => i.id)
      this.updateParticipants(this.sheetData.participants.filter(i => !removeArrMap.includes(i)))
    },
    handlePart(partList) {
      this.updateParticipants(this.sheetData.participants.concat(partList))
    },
    // 更新参与者
    updateParticipants(userIds) {
      updateParticipants(this.sheetData.sheetId, this.sheetData.id, userIds)
        .then(res => {
          if (res.data.code === 0) {
            this.sheetData.participants = this._.uniq(userIds)
            this.$message.success("操作成功!")
          } else this.$message.error("操作失败，请刷新重试")
        })
        .catch(err => {
          this.$message.error("操作失败，请刷新重试")
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.data-team {
  padding-bottom: 60px;
  height: 100%;
  .team {
    .team-content {
      .member-content {
        display: flex;
        padding: 0 10px 10px 13px;
        .member-avatar {
          .avatar {
            flex-shrink: 0;
          }
        }
        .member-info {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid #eaecf0;
          .name {
            width: 50px;
            margin: 0 8px;
            color: #303133;
            font-size: 13px;
          }
          .role {
            .el-tag {
              height: 20px;
              line-height: 18px;
              border-radius: 10px;
              font-size: 11px;
            }
            ::v-deep {
              .el-tag--info {
                background-color: #eaecf0;
                color: #303133;
              }
            }
          }
          .operation {
            .base-button {
              font-size: 12px;
              ::v-deep {
                .base-button--normal {
                  padding: 0 18px;
                }
              }
            }
          }
        }
      }
    }
  }
  .add-member {
    margin-left: 13px;
    display: flex;
    align-items: center;
    .base-button {
      font-size: 13px;
    }
  }
}
.member-dlg {
  ::v-deep .el-dialog {
    .el-dialog__header {
      padding: 0 24px;
      height: 64px;
      border-bottom: 2px solid #f5f5f5;
      .dlg-title {
        line-height: 64px;
      }
    }
    .el-dialog__body {
      .input-list {
        padding: 14px 24px 0 24px;
        .input-item {
          margin-bottom: 14px;
          .input-label {
            margin-bottom: 5px;
          }
        }
        .el-input__inner {
          width: 320px;
          height: 36px;
        }
      }
      .tail-row {
        padding: 0 24px;
        height: 62px;
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        border-top: 2px solid #f5f5f5;
        button {
          margin-left: 8px;
        }
      }
    }
  }
}
</style>
